import { FC } from 'react'

import { Header } from '../../Header'
import DeletedContent from '../../DeletedContent'
import { FeedActionsMenu } from '../../FeedActionsMenu'
import { type TFeedHeader } from '../types'

const FeedHeader: FC<TFeedHeader> = ({
  headerTitle,
  headerSubtitle,
  isNotAvailableContent,
  isQuotePost,
  isActions,
  canPinPost,
  isFeedAuthor,
  privacyOptionsVariant,
  renderFeed,
  renderEditModal,
  renderUserWrapper,
  isVisiblePinAction,
  ...feed
}) => {
  const isEdited = feed.updatedAt !== feed.createdAt
  const isReplyFeed = feed.path.length > 0

  return isNotAvailableContent ? (
    <DeletedContent />
  ) : (
    <Header
      feed={feed}
      title={headerTitle}
      subtitle={headerSubtitle}
      {...{
        isEdited,
        isQuotePost,
        renderUserWrapper,
        privacyOptionsVariant,
      }}
      time={feed.createdAt}
      isOriginalPoster={false}
      showOriginalPoster={false}
      showPrivacy={
        isReplyFeed && !isQuotePost
          ? feed.privacy !== 'FOLLOW_POST' &&
            feed.parent?.privacy !== 'FOLLOW_POST'
          : true
      }
      {...(isActions && {
        renderMenu: () => (
          <FeedActionsMenu
            isAuthor={isFeedAuthor}
            {...{
              feed,
              canPinPost,
              renderFeed,
              renderEditModal,
              isVisiblePinAction,
              privacyOptionsVariant,
            }}
          />
        ),
      })}
    />
  )
}

export default FeedHeader
